<template>
  <UikitDialog
    :model-value="modelValue"
    position="right"
    :full-height="laptopM || isDesktop"
    :hide-close="!(laptopM || isDesktop)"
    content-class="osk-return-dialog"
    @update:model-value="emits('update:model-value', $event)"
  >
    <div class="osk-return-dialog__content">
      <div class="osk-return-dialog__title">
        Как вернуть товар?
      </div>

      <template v-if="seller?.isPro">
        <div class="osk-return-dialog__subtitle">
          Бутик
        </div>

        <div class="osk-return-dialog__text">
          Если вещь вам не подошла – оформить возврат можно в течение 7 дней, обратившись в нашу службу поддержки.
        </div>
      </template>

      <template v-else-if="seller?.acceptsReturns">
        <div class="osk-return-dialog__subtitle">
          У некоторых частных продавцов есть возврат
        </div>

        <div class="osk-return-dialog__text">
          Если вещь, купленная у частного продавца с тегом «есть возврат» вам не подошла – обратитесь в нашу службу поддержки в течение 3&nbsp;дней после получения товара.
        </div>
      </template>

      <template v-else>
        <div class="osk-return-dialog__subtitle">
          Частный продавец
        </div>

        <div class="osk-return-dialog__text">
          Если вещь, купленная у частных продавцов, не соответствует заявленным характеристикам – обратитесь в нашу службу поддержки после получения заказа.
        </div>
      </template>

      <UikitButton
        class="osk-return-dialog__button"
        full-width
        @click="emits('update:model-value', false);"
      >
        Понятно
      </UikitButton>
    </div>
  </UikitDialog>
</template>

<script setup lang="ts">
import { UserDTO } from '~/restAPI/data-contracts';

const props = defineProps<{
  modelValue: boolean,
  seller?: UserDTO
}>();

const emits = defineEmits<{
  (e: 'update:model-value', value: boolean): void,
}>();

const { laptopM, isDesktop } = useUiBreakpoints();
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-return-dialog {
  display: flex;
  flex-direction: column;

  &__content {
    padding-top: 21px;

    @include media-query(md-and-up) {
      padding: 76px 28px 28px;
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }

  &__title {
    display: none;

    @include media-query(md-and-up) {
      @include font-style(22px, 27px, $font-weight-bold);
      margin-bottom: 32px;
      display: block;
    }
  }

  &__subtitle {
    @include font-style($font-size-heading, $line-height-heading, $font-weight-bold);
    margin-bottom: 24px;

    @include media-query(md-and-up) {
      @include font-style($font-size-body, $line-height-subheading, $font-weight-bold);
      margin-bottom: 24px;
    }
  }

  &__text {
    max-width: 372px;

    @include media-query(md-and-up) {
      line-height: $line-height-subheading;
    }
  }

  &__button {
    margin-top: $indent-mlarge;
    height: 52px !important;
    line-height: 52px !important;

    @include media-query(md-and-up) {
      margin-top: auto;
      height: 42px !important;
      line-height: 42px !important;
    }
  }
}
</style>
